"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpClient = void 0;
const axios_1 = __importStar(require("axios"));
const axios_retry_1 = __importStar(require("axios-retry"));
const http_client_error_1 = require("./http-client-error");
/**
 * Cria e retorna um HttpClient.
 *
 * Você pode definir várias opções padrões para esse HttpClient, porém
 * todas essas opções também podem ser customizadas de forma diferente
 * em cada requisição de forma independente.
 *
 * @public
 */
function createHttpClient(options = {}) {
    const defaultHeaders = {
        'Content-Type': 'application/json'
    };
    const axiosHttpClient = axios_1.default.create({
        baseURL: options.baseURL,
        headers: { ...defaultHeaders, ...options.headers },
        timeout: options.timeout,
        responseType: options.responseType,
        ...handleStatus()
    });
    /**
     * Retorna a mesma instância criada anteriormente com a função createHttpClient,
     * porém com o contexto de options passado como parâmetro para esta função
     */
    function withOptions(options = {}) {
        return exec(options);
    }
    function handleStatus() {
        return options.validateStatus ? { validateStatus: options.validateStatus } : {};
    }
    function init() {
        // a ordem aqui importa
        applyRetry();
        applyCustomRequestErrors();
    }
    function applyRetry() {
        var _a;
        (0, axios_retry_1.default)(axiosHttpClient, {
            retries: (_a = options.retries) !== null && _a !== void 0 ? _a : 0,
            retryDelay: axios_retry_1.exponentialDelay,
            // @ts-expect-error omitting properties
            retryCondition: options.retryCondition
        });
    }
    function parseRequestOptions(options) {
        const { abortSignal, retries, ...restOptions } = options;
        return {
            signal: abortSignal,
            'axios-retry': { retries },
            ...restOptions
        };
    }
    function get(optionsContext) {
        return (url, options = {}) => axiosHttpClient
            .get(url, parseRequestOptions({ ...optionsContext, ...options }))
            .then(response => response.data);
    }
    function post(optionsContext) {
        return (url, data, options = {}) => axiosHttpClient
            .post(url, data, parseRequestOptions({ ...optionsContext, ...options }))
            .then(response => response.data);
    }
    function patch(optionsContext) {
        return (url, data, options = {}) => axiosHttpClient
            .patch(url, data, parseRequestOptions({ ...optionsContext, ...options }))
            .then(response => response.data);
    }
    function put(optionsContext) {
        return (url, data, options = {}) => axiosHttpClient
            .put(url, data, parseRequestOptions({ ...optionsContext, ...options }))
            .then(response => response.data);
    }
    function deletee(optionsContext) {
        return (url, options = {}) => axiosHttpClient
            .delete(url, parseRequestOptions({ ...optionsContext, ...options }))
            .then(response => response.data);
    }
    function setHeadersOption(key, value) {
        axiosHttpClient.defaults.headers.common[key] = value;
    }
    function clearHeadersOption(key) {
        delete axiosHttpClient.defaults.headers.common[key];
    }
    function applyCustomRequestErrors() {
        axiosHttpClient.interceptors.response.use(undefined, error => {
            if (error instanceof axios_1.AxiosError) {
                const customRequestError = new http_client_error_1.HttpClientRequestError(error);
                /**
                 * Here we are disabling this rule for being able to reject
                 * this Promise without sending new Error('etc...')
                 */
                /* eslint prefer-promise-reject-errors: off */
                return Promise.reject({ ...customRequestError });
            }
            return Promise.reject(error);
        });
    }
    function applyRequestInterceptors({ onSuccess, onError }) {
        // @ts-expect-error omitting properties
        return axiosHttpClient.interceptors.request.use(onSuccess, onError);
    }
    function applyResponseInterceptors({ onSuccess, onError }) {
        return axiosHttpClient.interceptors.response.use(onSuccess, onError);
    }
    function ejectRequestInterceptor(ejectId) {
        axiosHttpClient.interceptors.request.eject(ejectId);
    }
    function ejectResponseInterceptor(ejectId) {
        axiosHttpClient.interceptors.response.eject(ejectId);
    }
    init();
    function exec(options) {
        return {
            get: get(options),
            put: put(options),
            post: post(options),
            patch: patch(options),
            delete: deletee(options),
            setHeadersOption,
            clearHeadersOption,
            applyRequestInterceptors,
            applyResponseInterceptors,
            ejectRequestInterceptor,
            ejectResponseInterceptor,
            withOptions
        };
    }
    return exec(options);
}
exports.createHttpClient = createHttpClient;
//# sourceMappingURL=http-client.js.map